module.exports = __webpack_public_path__ + "img/57.7.Chla.c86e3ff5.png";